import { ColorPaletteType, ThemeColorsType, ThemeTailwindType } from 'src/domains/common/themeColors';

export const energyColors: ThemeTailwindType = {
    '--primary': '58 79% 56%',
    '--menu-primary': '0 0% 100%',
    '--menu-secondary': '222 47% 11%',
};

const colorPalette: ColorPaletteType = {
    primary: '#1B1D21',
    secondary: '#E8E337',
    tertiary: '#FF6000',
    dark: '#09090B',
    shade1: '#0C0C0E',
    shade2: '#121214',
    shade3: '#1F1F23',
    shade4: '#2D2D33',
    shade5: '#36363B',
    shade6: '#CECED1',
    textDark: '#111111',
    textTertiary: '#FF6000',
    white: '#ffffff',
};

export const themeColors: ThemeColorsType = {
    header: {
        bgColor: colorPalette.dark,
        bgColorSecondary: colorPalette.primary,
        bgColorTertiary: colorPalette.secondary,
        bgColorQuaternary: colorPalette.secondary,

        borderColor: colorPalette.secondary,
        borderColorSecondary: colorPalette.secondary,

        txtColor: colorPalette.white,
        txtColorSecondary: colorPalette.secondary,
        txtColorTertiary: colorPalette.dark,
        txtColorQuaternary: colorPalette.white,
    },
    buttons: {
        bgColor: colorPalette.secondary,
        txtColor: colorPalette.textDark,
    },
    input: {
        bgColor: colorPalette.shade6,
    },
    colorPicker: {
        colors: colorPalette,
        bgDefault: colorPalette.shade1,
        txtDefault: colorPalette.white,
    },
    anniversaryModal: {
        bgColor: '',
        bgColorSecondary: '',
        bgColorTertiary: '',
        txtColor: '',
        txtColorSecondary: '',
        txtColorTertiary: '',
    },
    loginPage: {
        bgColor: colorPalette.secondary,
    },
    traderChat: {
        bgColor: colorPalette.white,
        borderColor: '#d6e6f2',
        borderColorSecondary: '#ccc',
        txtColor: '#888',
    },
    compliancePopup: {
        bgColor: '#09090B',
        txtColor: '#ffffff',
        bodyTxtColor: 'rgba(255, 255, 255, 0.8)',
        buttonBgColor: '#E8E337',
        buttonTxtColor: '#111111',
        secondaryBtnBgColor: 'rgba(255, 255, 255, 0.10)',
    },
};
